<template>
  <div>
    <div class="cpaCommission-box">
      <!-- cpa按钮组: 添加手数/删除手数 -->
      <div class="tableBtn-box" :style="version == '0' ? 'visibility:hidden;' : ''">
        <button class="btn btn-style-add" :disabled="!commission.enable || version == '0'" @click="addItem">
          <span class="glyphicon glyphicon-plus"></span>
          {{multiLanguage.btnGroup.addLots}}
        </button>
        <button class="btn btn-style-remove" :disabled="!commission.enable || version == '0'" @click="removeItem">
          <span class="glyphicon glyphicon-trash"></span>
          {{multiLanguage.btnGroup.removeLots}}
        </button>
      </div>
      <!-- cpa表格 -->
      <div class="table-box">
        <table class="table table-bordered" :class="{'table-striped' : commission.enable && version == '1','disabled': !commission.enable || version == '0'}">
          <thead>
            <tr>
              <th>{{multiLanguage.CPA.totalVolume}} >= 25 {{multiLanguage.CPA.LOT}}({{multiLanguage.CPA.remarks}})</th>
              <th>{{multiLanguage.CPA.commissionPer}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(cpaItem,index) in commission.cpa">
              <td>
                <input type="checkbox" v-if="version == '1'"
                  :disabled="!commission.enable || version == '0'"
                  :class="{'min-checkbox' : viewBtn == 'double'}"
                  :value="index" 
                  v-model="checkedCPAS"
                >
                <input type="text" v-model="cpaItem.start" v-if="index"
                  :disabled="!commission.enable || version == '0'"
                  :name="index+'_'+'cpaStart'"
                  :style="errors.has(index+'_'+'cpaStart') ? 'border-color:#f44336;' : ''"
                  v-validate="'required|min_value:1.00|decimal:2'"
                >
                <span v-else class="cpa-text">{{cpaItem.start ? cpaItem.start : '1.00'}}</span>
                <span>-</span>
                <input type="text" v-model="cpaItem.end" v-if="index !== commission.cpa.length-1"
                  :disabled="!commission.enable || version == '0'"
                  :name="index+'_'+'cpaEnd'"
                  :style="errors.has(index+'_'+'cpaEnd') ? 'border-color:#f44336;' : ''"
                  v-validate="'required|min_value:1.00|decimal:2'"
                >
                <span v-else class="cpa-text">{{multiLanguage.infinite}}</span>
              </td>
              <td>
                <input type="text" v-model="cpaItem.CPA" 
                  :disabled="!commission.enable || version == '0'"
                  :name="index+'_'+'cpaData'"
                  :style="errors.has(index+'_'+'cpaData') ? 'border-color:#f44336;' : ''"
                  v-validate="'required|min_value:0.01|decimal:2'"
                >
                <span></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    multiLanguage: {
      type: Object,
      default: {},
    },
    commission: {
      type: Object,
      default: {},
    },
    version: {
      type: String,
      default: ''
    },
    viewBtn: { 
      type: String,
      default: ''
    }
  },
  data () {
    return {
      checkedCPAS: []
    }
  },
  methods: {
    addItem () { // 添加手数的方法
      /**
       * 条件1 可以添加最多10条 
      */
      if (this.commission.cpa.length + this.checkedCPAS.length <= 10) {
        this.checkedCPAS.forEach(el => {
          let tem = {}
          let keys = Object.keys(this.commission.cpa[el])
          keys.forEach(item => { tem[item] = '' })
          this.commission.cpa.splice(el+1,0,tem)
        })
        this.checkedCPAS = []
      }
      else return
    },
    removeItem () { // 删除手数的方法
      /**
       * 条件1 最少保留一条
       */
      if (this.checkedCPAS.length > 0) {
        let msg = this.multiLanguage.btnGroup.confirmDeleteText
        if (confirm(msg) == true) {
          if (this.commission.cpa.length - this.checkedCPAS.length >= 1) {
            let tem = this.commission.cpa.concat([])
            this.checkedCPAS.forEach(item => {
              delete tem[item]
            })
            this.commission.cpa = tem.filter(item => item != null)
            this.checkedCPAS = []
          }
          else return
        }
      }
      else return
    },
  }
}
</script>

<style lang="scss" scoped>
  .cpaCommission-box{
    .tableBtn-box{
      text-align: right;
      margin-bottom: 10px;
      button{
        border-radius: 3px;
        span{
          font-size: 12px;
        }
      }
    }
    .table-box{
      table{
        text-align: center;
        thead th {
          text-align: center;
          span{
            display: inline-block;
            height: 31px;
            line-height: 31px;
          }
        }
        tbody tr td {
          position: relative;
          width: 50%;
        }
        input[type='text']{
          text-align: center;
          max-width: 80px;
          height: 30px;
          border: 1px solid #ddd;
          border-radius: 3px;
          margin: 0 5px;
          background-color: transparent;
        }
        input[type='checkbox']{
          position: absolute;
          top: 0;
          left: 0px;
          vertical-align: middle;
          margin-top: 0;
          width: 22px;
          height: 22px;
        }
        .min-checkbox{
          width: 15px!important;
          height: 15px!important;
        }
        .cpa-text{
          display: inline-block;
          width: 80px;
          height: 30px;
          line-height: 30px;
          margin: 0 5px;
        }
      }
    }
    .btn-style-add {
      background-color: #3f51b5;
      color:#fff;
    }
    .btn-style-remove {
      background-color:#f08712;
      color:#fff;
    }
  }
</style>





// WEBPACK FOOTER //
// cpaCommission.vue?165a1668